

export const InstallationTypeSectionIds = {
    Elevation: 'elevation-installation-config',
    Channel: 'channel-installation-config',
}

export enum ElevationInstallationFieldIds {
    ReferencePoint = 'elevation-reference-point',
    Datum = 'elevation-height',
    PhysicalOffset = 'elevation-physical-offset',
}

export enum ChannelInstallationFieldIds {
    Range = 'channel-range',
    NumberOfEntries = 'channel-numberOfEntries',
    EntriesSection = 'channel-entries-section',
    Depth = 'channel-depth',
    Quantity = 'channel-quantity',

    // array section
    ArraySection = 'channel-array-section',
}